import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BreadcrumbItem } from "src/appStore";
import {
  deleteValueCatalog,
  loadValueCatalog,
  saveValueCatalog,
} from "src/business/valueCatalog/apiValueCatalog";
import { ZValueCatalog } from "src/business/valueCatalog/ZValueCatalog";
import { mdmBreadcrumbs } from "src/common/mdmBreadcrumbs";
import { onError } from "src/common/onError";
import { RemoteData } from "src/common/RemoteData";
import { LoaderBox } from "src/components/LoaderBox";
import { msgQueueStore } from "src/components/MsgQueue";
import { PageLayout } from "src/components/PageLayout";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ValueCatalogForm } from "../ValueCatalogForm";

export const ManagValueCatalogEdit: React.FC = observer(() => {
  const { id = "" } = useParams();
  React.useEffect(() => {
    pageStore.init(id).catch(onError);
  }, [id]);
  return (
    <PageLayout title={pageStore.crumbs}>
      <LoaderBox
        remoteData={pageStore.data}
        drawReady={(data) => <Inner data={data} />}
      />
    </PageLayout>
  );
});

const Inner: React.FC<{ data: ZValueCatalog }> = observer(({ data }) => {
  const navigate = useNavigate();

  const onDelete = async () => {
    await deleteValueCatalog(data.id);
    navigate(makeUrl(PageUrl.managementValueCatalogs), { replace: true });
  };

  return (
    <ValueCatalogForm
      title={data.name}
      okText="Сохранить"
      srcData={data}
      onSubmit={(values) => saveValueCatalog(data.id, values)}
      onSuccess={(values) => {
        pageStore.setData({ status: "ready", result: values });
        msgQueueStore.add({ message: "Выполнено сохранение данных" });
      }}
      onDelete={onDelete}
    />
  );
});

const pageStore = makeAutoObservable({
  async init(id: string) {
    try {
      this.setData({ status: "wait" });
      const result = await loadValueCatalog(id);
      this.setData({ status: "ready", result });
    } catch (error) {
      this.setData({ status: "error", error });
    }
  },
  data: { status: "none" } as RemoteData<ZValueCatalog>,
  setData(newData: RemoteData<ZValueCatalog>) {
    this.data = newData;
  },
  get crumbs(): BreadcrumbItem[] {
    const { data } = this;
    const name = (data.status === "ready" && data.result.name) || "...";
    return mdmBreadcrumbs([
      { type: "ObjAndSpecs" },
      { type: "AdminValueCatalogs" },
      { type: "Name", name },
    ]);
  },
});
